import api from '../../assets/js/api.js'

const state = {
  productList: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  productTeaserList: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  selectedProduct: null
}

const getters = {
  product_get_list: state => {
    return state.productList
  },
  product_get_teaser_list: state => {
    return state.productTeaserList
  },
  product_get_selected_product: state => {
    return state.selectedProduct
  }
}

const mutations = {
  PRODUCT_SET_SELECTED_PRODUCT (state, product) {
    state.selectedProduct = product
  },
  PRODUCT_SET_LIST (state, productList) {
    state.productList = productList
  },
  PRODUCT_LIST_PAGE (state, productList) {
    var data = state.productList.data.concat(productList.data)
    state.productList = {
      data: data,
      links: productList.links,
      meta: productList.meta
    }
  },
  PRODUCT_SET_TEASER_LIST (state, productTeaserList) {
    state.productTeaserList = productTeaserList
  }
}

const actions = {
  getProductList ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getProductList')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getProductList')
      api.getProductList(12).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getProductList')
          console.log(response)
          commit('PRODUCT_SET_LIST', response)
          if (payload && payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getProductList')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getProductTeaserList ({ rootGetters, commit }) {
    if (!rootGetters.global_is_busy_method('getProductTeaserList')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getProductTeaserList')
      api.getProductList(8).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getProductTeaserList')
          console.log(response)
          commit('PRODUCT_SET_TEASER_LIST', response)
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getProductTeaserList')
          console.log(error)
        }
      )
    }
  },
  getShopProduct ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getShopProduct')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopProduct')
      api.getProductDetails(payload.product).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopProduct')
          commit('PRODUCT_SET_SELECTED_PRODUCT', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopProduct')
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js